<template>
    <div class="flex flex-row-reverse flex-wrap gallery-list-dashed -mx-4 overflow-hidden">
        <div v-for="(i, index) in count"
            :key="index" 
            class="flex flex-row-reverse w-full p-4 border-t border-l border-dashed border-black-three sm:flex-col sm:w-1/2 lg:w-1/4">
            <div class="bg-cloudy-blue opacity-50 flex-shrink-0 w-full mb-5 h-174px article-loading"></div>
            <div class="w-full flex flex-col items-end">
                <div class="w-full h-4 bg-cloudy-blue opacity-50 mb-4 article-loading"></div>
                <div class="w-1/3 h-4 bg-cloudy-blue opacity-50 mb-10 article-loading"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        count: {
            type: Number,
            default: 4
        }
    }
}
</script>